// const localDomain = 'localhost';
const devDomain = 'shieldweb.linkface.cn';
const devCloud = 'cloudapi.linkface.cn';
const prodDomain = 'shieldweb.linkface.cn';
const prodCloud = 'cloudapi.linkface.cn';

export default {
  stg: {
    domain: devDomain,
    proxy: `http://${devDomain}:8090`,
    cloud: `http://${devCloud}`,
  },

  prod: {
    domain: prodDomain,
    proxy: `http://${prodDomain}:8090`,
    cloud: `http://${prodCloud}`,
  },
};
